module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('button', {
    staticClass: "btn add-btn",
    class: {
      'flash': _vm.isValid
    },
    on: {
      "click": _vm.addToBetslip
    }
  }, [_c('i', {
    staticClass: "n-i n-i-betslip-options"
  }), _vm._v("\n\n    " + _vm._s(_vm._f("translate")(_vm.bettingSvc.updateBet ? 'update_bet' : 'add_bet')) + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn clear-btn",
    on: {
      "click": _vm.clearBetting
    }
  }, [_c('span', {
    staticClass: "n-i n-i-trash"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tabs-list"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      ref: tab.name,
      refInFor: true,
      staticClass: "tab",
      class: {
        'is--active': tab.isActive
      },
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "tabs-title"
    }, [_vm._v(_vm._s(_vm._f("translate")(tab.name)))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "tabs-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b9df73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tabs.vue
// module id = 403
// module chunks = 0